<ion-content>

  <ion-row>
    <ion-col size="12" sizeMd="4" *ngFor="let election of es.electionList">
      <ion-card class="margin5px" (click)="clickElection(election)">
        <ion-row>
          <ion-col size="12" class="primaryBg font1_2 padding5 ion-text-center">
            {{election.heading}}
          </ion-col>

          <ion-col size="6" class="borderMedium">Candidate Finalize</ion-col>
          <ion-col size="6" class="borderMedium">{{election.candidate_final_date | fancyDate}}</ion-col>

          <ion-col size="6" class="borderMedium">Member Finalize</ion-col>
          <ion-col size="6" class="borderMedium">{{election.member_final_date | fancyDate}}</ion-col>

          <ion-col size="6" class="borderMedium">Result</ion-col>
          <ion-col size="6" class="borderMedium">{{election.result_date | fancyDate}}</ion-col>

          <ion-col size="4" class="borderMedium bold">Election Start</ion-col>
          <ion-col size="4" class="borderMedium">{{election.election_start_date | fancyDate}}</ion-col>
          <ion-col size="4" class="borderMedium">{{election.election_end_date | fancyDate}}</ion-col>
        </ion-row>
      </ion-card>
    </ion-col>
  </ion-row>

</ion-content>
<ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="cs.myMemberShip?.role=='Admin'">
  <ion-fab-button color="secondary" (click)="clickElection(null)">
    <ion-icon name="add"></ion-icon>
  </ion-fab-button>
</ion-fab>